import { useFilterDisabledSettings } from "@api";
import { TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { AutocompleteSettings } from "@styleguide";
import equal from "fast-deep-equal/react";
import { useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterPrescriber = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["prescribers"]>) => {
  const { settings } = useGlobalContext();

  const settingsPrescriber = useFilterDisabledSettings(settings?.settingsSources ? settings.settingsSources : []);
  const [localValue, setLocalValue] = useState(value);

  const handleDispatch = () => {
    if (!equal(localValue, value)) {
      dispatch({ type: "prescribers", payload: localValue });
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <AutocompleteSettings
      multiple
      options={settingsPrescriber}
      value={localValue}
      onBlur={handleDispatch}
      onChange={(_, prescribers, reason) => {
        setLocalValue(prescribers);
        if (reason === "removeOption") {
          dispatch({ type: "prescribers", payload: prescribers });
        }
      }}
      renderInput={(params) => <TextField {...params} label="Prescripteur" size="small" />}
      ChipProps={{
        color: "yellow",
        size: "small",
        sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
      }}
      limitTags={2}
    />
  );
};
